import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import apiCall from "../api";
import t from "../translate";
import { getClone } from "../utils";
import { setChosenImage } from "../../actions";

const MediaLibrary = props => {
  //////////////////////
  ///Constantes
  const [state, setState] = useState({
    images: []
  });
  const appUrl = useSelector(state => state.url);
  const auth = useSelector(state => state.auth);
  const intervention = useSelector(state => state.intervention);
  //const [dir, setDir] = useState('-99');
  const [message, setMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const dispatch = useDispatch();
  const medialibrary = useSelector(state => state.mediaLibrary);

  /////////////////////////////////////////////
  ///////Data handling with server
  ////////////////////////////////////////////

  //////////////////////
  ///Get content
  useEffect(() => {
    if(props.mediaLibraryVisible == "show")
    {
      getImages();  // TODO nu maakt die elke keer verbinding... misschien 1 keer genoeg en dan filteren in js
    }

  }, [props]);

  //////////////////////
  ///Load content urls from server
  function getImages() {
    let apiMsg = {
      action: "get_all_images",
      token: auth.token,
      data: {
        intervention_id: intervention.id,
        filterTypes: props.filterTypes
      }
    };

    apiCall(apiMsg).then(resp => {
      if (false !== resp) {
        if (resp.images) {
          setState({images:resp.images});
        }
      }
    });
  }

  //////////////////////
  ///Upload image to server
  function uploadImage(uploadedFiles) {
    let promises = [];
    let files = [];
    Array.from(uploadedFiles).forEach(uploadFile => {
      let filePromise = new Promise(resolve => {
        let reader = new FileReader();
        reader.readAsDataURL(uploadFile);
        reader.onload = e => {
          let file = {};
          file.type = uploadFile.type;
          file.name = uploadFile.name;
          file.size = uploadFile.size;
          file.content = e.target.result;
          files.push(file);
          resolve(true);
        };
      });
      promises.push(filePromise);
    });
    Promise.all(promises).then(fileContents => {
      let apiObj = {
        action: "upload_image",
        token: auth.token,
        data: {
          intervention_id: intervention.id,
          files: files
        }
      };

      apiCall(apiObj).then(resp => {
        if (resp) {
          let newState = getClone(state);
          resp.urls.forEach(url => {
            newState.images.push(url);
          });
          setState(newState);
        }
      });
    });
  }

  //////////////////////
  ///Delete image from server
  function deleteImage(e, name, index) {
    e.stopPropagation();

    let apiMsg = {
      action: "delete_image",
      token: auth.token,
      data: {
        name,
        index,
        intervention_id: intervention.id
      }
    };

    apiCall(apiMsg).then(resp => {
      if (false !== resp) {
        if (resp.name) {
          let newState = getClone(state);
          newState.images = newState.images.filter(function(image) {
            return image != name;
          });
          setState(newState);
        }
      }
    });
  }

  ////////////////////////////////////////////
  /////////Select action <= store in redux store => empty after action
  ///////////////////////////////////////////
  function selectImage(image) {
    ///set chosen image on hide
    hideMediaLibrary(image);
  }

  ////////////////////////////////////////////
  /////////Hide mediaLibrary
  ///////////////////////////////////////////
  function hideMediaLibrary(image) {
    document.body.style.overflow = "unset";
    props.setMediaLibraryVisible("hide");
    setState({images:[]});

    let theDir = intervention.id;
    if (intervention.id === 0) {
      theDir = -99;
    }

    if (image) {
      image = theDir + "/" + image;

      /// place in redux store
      dispatch(setChosenImage(image, medialibrary.index));
    }
  }

  ////////////////////////////////////////////
  /////////Image action
  ///////////////////////////////////////////
  let inputFileRef = React.createRef();
  function triggerInputFile() {
    inputFileRef.current.click();
  }

  ////////////////////////////////////////////
  /////////Get file
  ///////////////////////////////////////////
  function getFile(upload, index) {

    var ext = upload.substr(upload.lastIndexOf('.') + 1);

    if(ext.toLowerCase() == "mp3"){
      return(
        <div
          key={index}
          className="image"
          onClick={e => selectImage(upload)}
        >
          <div className="notAnImage" title={upload}>
            <i className="fas fa-volume-up"></i>
            {upload}
          </div>
          <i
            className="fas fa-trash"
            onClick={e => deleteImage(e, upload, index)}
          ></i>
        </div>
      )
    } 
    else if(ext.toLowerCase() == "xlsx"){
      return(
        <div
          key={index}
          className="image"
          onClick={e => selectImage(upload)}
        >
          <div className="notAnImage" title={upload}>
            <i className="fas fa-file-excel"></i>
            {upload}
          </div>
          <i
            className="fas fa-trash"
            onClick={e => deleteImage(e, upload, index)}
          ></i>
        </div>
      )
    } 
    else if(ext.toLowerCase() == "docx"){
      return(
        <div
          key={index}
          className="image"
          onClick={e => selectImage(upload)}
        >
          <div className="notAnImage" title={upload}>
            <i className="fas fa-file-word"></i>
            {upload}
          </div>
          <i
            className="fas fa-trash"
            onClick={e => deleteImage(e, upload, index)}
          ></i>
        </div>
      )
    } else {
      let theDir = intervention.id;
      if (intervention.id === 0) {
        theDir = -99;
      }
      return(
        <div
          key={index}
          className="image"
          style={{
            backgroundImage:
              "url(\""+appUrl+"/uploads/intervention/" +
              theDir +
              "/" +
              encodeURI(upload) +
              "\")"
          }}
          onClick={e => selectImage(upload)}
          title={upload}
        >
          <i
            className="fas fa-trash"
            onClick={e => deleteImage(e, upload, index)}
          ></i>
        </div>
      )
    }
  }

  ////////////////////////////////////////////
  /////////Content
  ///////////////////////////////////////////
  return (
    <div className={"mediaLibrary " + props.mediaLibraryVisible}>
      <div className="popup">
        <i className="fas fa-times" onClick={() => hideMediaLibrary()}></i>
        <h4>Bibliotheek {intervention.title}</h4>
        <input
          type="file"
          onChange={e => uploadImage(e.target.files)}
          name="file"
          ref={inputFileRef}
          multiple={true}
        />
        <span className="btn btn-primary" onClick={triggerInputFile}>
          Upload <i className="fas fa-upload"></i>
        </span>
        <div className="items">
          {state.images.length > 0
            ? state.images.map((image, index) => (
                getFile(image, index)
              ))
            : ""}
        </div>
      </div>
      <div className="overlay" onClick={() => hideMediaLibrary()}></div>
    </div>
  );
};

export default MediaLibrary;
